<template>
  <ReaderOverlayTop
    v-model:menuOpen="menuOpen"
    :active
    :solo
    :overlay-text="[titleTitle, chapterTitle].filter(onlyTruthys).join(', ')"
    :return-href="href || undefined"
    @return="emit('return')"
  >
    <template #buttons v-if="!solo">
      <NamiButton
        buttonType="secondary"
        :icon="IconBookmark"
        hideTextOnSmallScreen
        pill
        :text="secondaryMenuOpen !== 'bookmarks'"
        @buttonClick="toggleMenu('bookmarks')"
        :force-icon-only="!loggedIn"
      >
        {{ bookmarks ?? 0 }}
      </NamiButton>
      <NamiButton
        buttonType="secondary"
        :icon="IconMessageCircle2"
        hideTextOnSmallScreen
        pill
        :text="secondaryMenuOpen !== 'comments'"
        @buttonClick="toggleMenu('comments')"
      >
        {{ comments ?? 0 }}
      </NamiButton>
      <NamiButton
        :buttonType="liked ? 'primary' : 'secondary'"
        :icon="liked ? IconHeartFilled : IconHeart"
        hideTextOnSmallScreen
        pill
        text
        :disabled="disableLike"
        @buttonClick="emit('toggleLike')"
      >
        {{ likes ?? 0 }}
      </NamiButton>
    </template>
  </ReaderOverlayTop>
</template>

<script setup lang="ts">
import {
  IconBookmark,
  IconHeart,
  IconHeartFilled,
  IconMessageCircle2,
} from "@tabler/icons-vue";
import type {
  NovelSettingsInterface,
  NovelSettingsType,
} from "~/src/novel/reader";
import { type NovelChapterEntity, type TitleEntity } from "~/src/api";

const loggedIn = useIsLoggedIn();
const appStore = useAppStore();

const { solo, title, chapter } = defineProps<{
  title?: TitleEntity;
  chapter?: NovelChapterEntity;
  liked?: boolean;

  likes?: number;
  comments?: number;
  bookmarks?: number;

  disableLike?: boolean;
  active?: boolean;
  solo?: boolean;
}>();
const emit = defineEmits<{
  (e: "return"): void;
  (e: "toggleLike"): void;
}>();

const menuOpen = defineModel<boolean>("menuOpen", { required: true });
const secondaryMenuOpen = defineModel<
  NovelSettingsInterface["secondaryMenuOpen"]
>("secondaryMenuOpen", { required: true });

const { title: titleTitle, href } = parseTitleForDisplay(computed(() => title));

const chapterTitle = computed(() => {
  if (!chapter) return;
  return getChapterName(chapter, title, "long");
});

const toggleMenu = (menu: NovelSettingsInterface["secondaryMenuOpen"]) => {
  if (menu === "bookmarks" && !loggedIn.value) {
    appStore.openLoginRequiredModal();
    return;
  }

  if (secondaryMenuOpen.value === menu) secondaryMenuOpen.value = false;
  else secondaryMenuOpen.value = menu;
};
</script>
